module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searches.length),
      expression: "searches.length"
    }],
    staticClass: "search-list"
  }, [_c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "ul"
    }
  }, _vm._l((_vm.searches), function(item) {
    return _c('li', {
      key: item,
      staticClass: "search-item",
      on: {
        "click": function($event) {
          _vm.selectItem(item)
        }
      }
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item))]), _vm._v(" "), _c('span', {
      staticClass: "icon",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.deleteOne(item)
        }
      }
    }, [_c('i', {
      staticClass: "icon-delete"
    })])])
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-387b8eba","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/base/search-list/search-list.vue
// module id = 533
// module chunks = 9